import { Component, OnInit, Input } from '@angular/core';
import { TravelAgendaModel } from '../../../models/consultation-history/travel-agenda.model';
import { ConsultationHistoryService } from '../consultation-history.service';
import { allResolved } from 'q';
import { AppConstants } from '../../../shared/constants/constants';

@Component({
    selector: 'ch-travel-agenda',
    templateUrl: 'travel-agenda.component.html'
})

export class TravelAgendaComponent implements OnInit {
    public appConstants = AppConstants;
    @Input() history = false;
    @Input() travelAgenda: any[];
    travels = null;
    @Input() tripCountries = [];
    public histories = [];
    public klass = 'consultationhistory';

    constructor(public consultationHistoryService: ConsultationHistoryService) {
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-history/travel-agenda/travel-agenda.component.ts